import React from 'react';
import { DatabaseBackup, Clock, History, Cloud, Repeat, ShieldCheck } from 'lucide-react';
import './SecurityCompliance.css';

const DataBackup = () => {
  return (
    <div className="security-page">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-copy">
            <div className="status-badge">
              <History size={14} /> Last Backup: 30 minutes ago
            </div>
            <h1>Immutable Data Backup & Instant Recovery</h1>
            <p>
              Protect your business from data loss, ransomware, and hardware failure 
              with automated, geo-redundant backup solutions.
            </p>
            <div className="hero-actions">
              <a className="button primary" href="#contact">Setup Backups</a>
              <a className="button secondary" href="#recovery">Recovery Speed</a>
            </div>
          </div>
          <div className="hero-panel">
            <div className="panel-card panel-glow">
              <DatabaseBackup className="icon" size={48} />
              <h3>99.999% Durability</h3>
              <p>Your data is replicated across multiple secure data centers globally.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="features" className="section">
        <div className="section-heading">
          <span className="eyebrow">Resilience</span>
          <h2>Your data, always available.</h2>
          <p>We provide a safety net for your most critical assets, ensuring that no matter what happens, you are back online in minutes.</p>
        </div>

        <div className="security-grid">
          <div className="security-card">
            <div className="sec-icon"><Clock size={24} /></div>
            <h3>Point-in-Time Recovery</h3>
            <p>Roll back your entire system to any specific minute in the last 30 days with a single click.</p>
          </div>
          <div className="security-card">
            <div className="sec-icon"><Cloud size={24} /></div>
            <h3>Off-Site Replication</h3>
            <p>Encryption-at-rest backups stored in isolated environments to prevent ransomware spread.</p>
          </div>
          <div className="security-card">
            <div className="sec-icon"><Repeat size={24} /></div>
            <h3>Zero-Data-Loss (ZDL)</h3>
            <p>Real-time continuous data protection for high-transaction enterprise applications.</p>
          </div>
        </div>
      </section>

      <section className="section bg-glass" id="recovery">
        <div className="feature-block">
          <div className="solution-copy">
            <h3>Disaster Recovery as a Service</h3>
            <p>
              It is not just about the backup; it is about the recovery. We test 
              your restoration process monthly to ensure perfection when it counts.
            </p>
            <ul className="feature-list-alt">
              <li className="feature-item-alt">
                <ShieldCheck size={20} className="sec-icon-inline" />
                <div>
                  <h4>RTO &lt; 15 Minutes</h4>
                  <p>Recovery Time Objective: Get your services back online in under quarter hour.</p>
                </div>
              </li>
              <li className="feature-item-alt">
                <ShieldCheck size={20} className="sec-icon-inline" />
                <div>
                  <h4>Automated Testing</h4>
                  <p>Daily integrity checks on all backup archives to prevent data corruption.</p>
                </div>
              </li>
            </ul>
          </div>
          <div className="encryption-visual">
             <Cloud className="lock-animation" size={100} color="#10b981" />
          </div>
        </div>
      </section>

      <div className="metrics-grid" style={{maxWidth: '1240px', margin: '0 auto 80px'}}>
        <div className="metric-item">
          <strong>15min</strong>
          <span>Max Recovery Time</span>
        </div>
        <div className="metric-item">
          <strong>AES-256</strong>
          <span>Backup Encryption</span>
        </div>
        <div className="metric-item">
          <strong>3</strong>
          <span>Global Locations</span>
        </div>
        <div className="metric-item">
          <strong>Daily</strong>
          <span>Verified Tests</span>
        </div>
      </div>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Don't wait for a crash to care about backups.</h2>
          <p>Protect your business continuity today with our enterprise-grade backup suite.</p>
          <a className="button primary" href="#contact">Start Free Trial</a>
        </div>
      </section>
    </div>
  );
};

export default DataBackup;
